<div class="contact-container">
  <!-- Header -->
  <div class="header-section">
    <div class="left">
      <h2>Contact Us</h2>
      <p>
        Reach out to us for any inquiries or assistance. Our team is here to
        help.
      </p>
    </div>

    <!-- Primary Contact -->
    <div class="primary-contact" [hidden]="loading || contacts.length === 0">
      <h3>
        {{ contacts[0]?.firstName }}
        {{ contacts[0]?.lastName }}
      </h3>

      <p class="contact-title">
        {{ contacts[0]?.title }}
      </p>

      <div class="contact-detail" *ngIf="contacts[0]?.phoneNumber">
        <span class="contact-detail-label">Phone</span>

        <a class="contact-link" [href]="'tel:' + contacts[0]?.phoneNumber">
          {{ formatPhoneNumber(contacts[0]?.phoneNumber) }}
        </a>
      </div>

      <div class="contact-detail" *ngIf="contacts[0]?.emailAddress?.email">
        <span class="contact-detail-label">Email</span>

        <a
          class="contact-link"
          [href]="'mailto:' + contacts[0]?.emailAddress?.email"
        >
          {{ contacts[0]?.emailAddress?.email }}
        </a>
      </div>
    </div>

    <!-- Primary Contact Skeleton -->
    <div class="primary-contact skeleton" [hidden]="!loading">
      <div class="skeleton-line" style="width: 40%; height: 14px;"></div>

      <div class="skeleton-line" style="width: 70%; height: 22px;"></div>

      <div class="skeleton-line" style="width: 50%; height: 18px;"></div>

      <div class="skeleton-line" style="width: 60%; height: 16px;"></div>

      <div class="skeleton-line" style="width: 80%; height: 16px;"></div>
    </div>
  </div>

  <div class="spacing-divider"></div>

  <!-- Error Message -->
  <div class="primary-contact error-message" [hidden]="!errorMessage">
    <span class="contact-section-label">Unable to load contacts</span>
    <p>{{ errorMessage }}</p>
  </div>

  <!-- Grid Section -->
  <div class="contact-grid-section">
    <!-- Grid Skeleton -->
    <div class="contact-grid" [hidden]="!loading">
      <div class="contact-card skeleton" *ngFor="let n of [1, 2, 3, 4, 5, 6]">
        <div class="skeleton-line" style="width: 80%; height: 20px;"></div>

        <div class="skeleton-line" style="width: 60%; height: 16px;"></div>

        <div class="skeleton-line" style="width: 70%; height: 16px;"></div>
      </div>
    </div>

    <!-- Contacts Grid -->
    <div class="contact-grid" [hidden]="loading || contacts.length <= 1">
      <div class="contact-card" *ngFor="let contact of contacts.slice(1)">
        <h4>
          {{ contact.firstName }}
          {{ contact.lastName }}
        </h4>

        <p class="contact-title">
          {{ contact.title }}
        </p>

        <div class="contact-detail" *ngIf="contact.phoneNumber">
          <span class="contact-detail-label">Phone</span>

          <a class="contact-link" [href]="'tel:' + contact.phoneNumber">
            {{ formatPhoneNumber(contact.phoneNumber) }}
          </a>
        </div>

        <div class="contact-detail" *ngIf="contact.emailAddress?.email">
          <span class="contact-detail-label">Email</span>

          <a
            class="contact-link"
            [href]="'mailto:' + contact.emailAddress?.email"
          >
            {{ contact.emailAddress?.email }}
          </a>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div
      class="primary-contact"
      [hidden]="loading || errorMessage || contacts.length > 0"
    >
      <span class="contact-section-label">Contact Information</span>
      <p>No contact information available.</p>
    </div>
  </div>
</div>
